import { Box, Spinner, Text } from "@saleor/macaw-ui-next";
import React from "react";

interface ExtensionLoadingStateProps {
  message: string;
  minHeight?: string;
}

export const ExtensionLoadingState: React.FC<ExtensionLoadingStateProps> = ({
  message,
  minHeight = "280px",
}) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    gap={3}
    borderWidth={1}
    borderStyle="solid"
    borderColor="default1"
    borderRadius={4}
    __minHeight={minHeight}
    padding={6}
  >
    <Spinner />
    <Text color="default2">{message}</Text>
  </Box>
);
